import { useForm } from "react-hook-form";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import MypageTextField from "../../../ui/MypageTextField";
import MypageSelect from "../../../ui/MypageSelect";
import MypagePostcodeTextField from "../../../ui/MypagePostcodeTextField";
import MypageTextAreaField from "../../../ui/MypageTextAreaField";
import MypageRadioField from "../../../ui/MypageRadioField";
import Header from "../../../layout/mypage/Header";
import Footer from "../../../layout/mypage/Footer";
import {
  validateEmailAddress,
  validateConfirm,
  validatePhoneWithoutHyphen,
} from "../../../../utils/validate";
import { postInquiry } from "../../../../services/apiInquiry";
import ScreenColorSetting, {
  getDefaultScreenColor,
} from "../../../layout/mypage/ScreenColorSetting";
import { MYPAGE_HTML_TITLE } from "../../../../utils/config";

const Inquiry = () => {
  // 同意したかどうかのフラグ
  const [isConsent, setConsent] = useState(false);
  // 確認画面かどうかのフラグ
  const [isConfirmation, setIsConfirmation] = useState(false);
  // お問い合わせ完了フラグ
  const [compFlg, setCompFlg] = useState(false);
  // 画面背景色 color-standard or color-black or color-blue
  const [screenColor, setScreenColor] = useState(getDefaultScreenColor());
  //ラジオボタン選択値
  const [selectedIsRequiredAnswer, setSelectedIsRequiredAnswer] =
    useState(true);
  const [selectedContent, setSelectedContent] = useState(true);

  const location = useLocation();
  const prevlink = location?.state?.prevlink;
  const isMypage = location?.state?.isMypage;

  // 回答要否選択肢
  const isRequiredAnswerOptions = [
    { value: "回答不要", text: "回答不要", defaultChecked: true },
    { value: "回答希望", text: "回答希望" },
  ];

  // お問い合わせ内容選択肢
  const contentOptions = [
    {
      value: "登録した学生番号・メールアドレスを知りたい",
      text: "登録した学生番号・メールアドレスを知りたい",
      defaultChecked: true,
    },
    { value: "掲載中のイベントについて", text: "掲載中のイベントについて" },
    {
      value: "団体・イベントをシブカツに掲載したい",
      text: "団体・イベントをシブカツに掲載したい",
    },
    {
      value: "シブカツWebサイト・窓口について",
      text: "シブカツWebサイト・窓口について",
    },
    { value: "その他のご質問・ご相談", text: "その他のご質問・ご相談" },
  ];

  // 年代選択肢
  const ageOptions = [
    { value: "50代未満", text: "50代未満" },
    { value: "50代", text: "50代" },
    { value: "60代", text: "60代" },
    { value: "70代", text: "70代" },
    { value: "80代以上", text: "80代以上" },
  ];

  // 都道府県選択肢
  const prefOptions = [
    { value: "北海道", text: "北海道" },
    { value: "青森県", text: "青森県" },
    { value: "岩手県", text: "岩手県" },
    { value: "宮城県", text: "宮城県" },
    { value: "秋田県", text: "秋田県" },
    { value: "山形県", text: "山形県" },
    { value: "福島県", text: "福島県" },
    { value: "茨城県", text: "茨城県" },
    { value: "栃木県", text: "栃木県" },
    { value: "群馬県", text: "群馬県" },
    { value: "埼玉県", text: "埼玉県" },
    { value: "千葉県", text: "千葉県" },
    { value: "東京都", text: "東京都" },
    { value: "神奈川県", text: "神奈川県" },
    { value: "新潟県", text: "新潟県" },
    { value: "富山県", text: "富山県" },
    { value: "石川県", text: "石川県" },
    { value: "福井県", text: "福井県" },
    { value: "山梨県", text: "山梨県" },
    { value: "長野県", text: "長野県" },
    { value: "岐阜県", text: "岐阜県" },
    { value: "静岡県", text: "静岡県" },
    { value: "愛知県", text: "愛知県" },
    { value: "三重県", text: "三重県" },
    { value: "滋賀県", text: "滋賀県" },
    { value: "京都府", text: "京都府" },
    { value: "大阪府", text: "大阪府" },
    { value: "兵庫県", text: "兵庫県" },
    { value: "奈良県", text: "奈良県" },
    { value: "和歌山県", text: "和歌山県" },
    { value: "鳥取県", text: "鳥取県" },
    { value: "島根県", text: "島根県" },
    { value: "岡山県", text: "岡山県" },
    { value: "広島県", text: "広島県" },
    { value: "山口県", text: "山口県" },
    { value: "徳島県", text: "徳島県" },
    { value: "香川県", text: "香川県" },
    { value: "愛媛県", text: "愛媛県" },
    { value: "高知県", text: "高知県" },
    { value: "福岡県", text: "福岡県" },
    { value: "佐賀県", text: "佐賀県" },
    { value: "長崎県", text: "長崎県" },
    { value: "熊本県", text: "熊本県" },
    { value: "大分県", text: "大分県" },
    { value: "宮崎県", text: "宮崎県" },
    { value: "鹿児島県", text: "鹿児島県" },
    { value: "沖縄県", text: "沖縄県" },
  ];

  // 入力チェック用
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    watch,
    formState: { errors },
  } = useForm();

  // 同意するチェック
  const ConsentCheck = (e) => {
    setConsent(e.target.checked);
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  // 入力画面へ戻る
  const handleBackConfirmation = () => {
    setIsConfirmation(false);
    scrollTop();
  };

  // 送信するボタン
  const onSubmit = async (data) => {
    if (isConfirmation) {
      const json = await postInquiry(data);
      if (json?.result) {
        setCompFlg(true);
        scrollTop();
      }
    } else {
      setIsConfirmation(true);
      scrollTop();
    }
  };

  useEffect(() => {
    (function () {
      document.title = `お問い合わせ | ${MYPAGE_HTML_TITLE}`;
      scrollTop();
    })();
  }, []);

  return (
    <>
      <ScreenColorSetting screenColor={screenColor} />
      <div className="mypage-site">
        <div className="mypage">
          <Header
            setScreenColor={setScreenColor}
            screenColor={screenColor}
            isLogin={false}
            isMypage={typeof isMypage !== "undefined" ? true : false}
          />

          <main className="l-main">
            <div className="container">
              <div className="col-lg-10 offset-lg-1">
                <div className="p-login-con">
                  {compFlg ? (
                    <>
                      <h1 className="p-heading01">お問い合わせを承りました</h1>
                      <p>お問い合わせを承りました。</p>
                      <p>
                        ご相談・お問合せ内容に合わせて担当者よりご連絡致します。
                      </p>
                      <p>
                        内容によってはお返事にお時間をいただく場合がございますので、ご了承ください。
                      </p>
                      <div className="p-login-form__btnbox">
                        <a
                          href={
                            process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"
                          }
                        >
                          <input
                            className="p-login-form__link"
                            type="button"
                            value="シブカツトップページに戻る"
                          />
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <h1 className="p-heading01">
                        {isConfirmation
                          ? "お問い合わせ内容確認"
                          : "お問い合わせ"}
                      </h1>
                      <form
                        className="p-login-form"
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <div className="p-login-con__form p-admission__form">
                          <MypageRadioField
                            name="is_required_answer"
                            label="回答"
                            elements={isRequiredAnswerOptions}
                            register={register}
                            errors={errors}
                            watch={watch}
                            required={true}
                            isStatic={isConfirmation}
                            selectedValue={selectedIsRequiredAnswer}
                            setSelectedValue={setSelectedIsRequiredAnswer}
                          />
                          <MypageRadioField
                            name="content"
                            label="お問い合わせ内容"
                            elements={contentOptions}
                            register={register}
                            errors={errors}
                            watch={watch}
                            required={true}
                            isStatic={isConfirmation}
                            selectedValue={selectedContent}
                            setSelectedValue={setSelectedContent}
                          />
                          <MypageTextAreaField
                            name="detail"
                            label="お問い合わせ内容(詳細)"
                            maxLength={1000}
                            register={register}
                            watch={watch}
                            errors={errors}
                            required={true}
                            isStatic={isConfirmation}
                          />
                          <MypageTextField
                            name="name"
                            label="お名前(漢字)"
                            maxLength={30}
                            register={register}
                            errors={errors}
                            watch={watch}
                            required={true}
                            placeholder="渋谷太郎"
                            isStatic={isConfirmation}
                          />
                          <MypageTextField
                            name="name_kana"
                            label="お名前(フリガナ)"
                            maxLength={30}
                            register={register}
                            errors={errors}
                            watch={watch}
                            required={true}
                            placeholder="シブヤタロウ"
                            isStatic={isConfirmation}
                          />
                          <MypageSelect
                            name="age"
                            label="年代"
                            register={register}
                            errors={errors}
                            required={true}
                            isStatic={isConfirmation}
                            options={ageOptions}
                            watch={watch}
                            isSetdefalut={true}
                          />
                          <MypageTextField
                            name="mail"
                            label="メールアドレス"
                            maxLength={100}
                            register={register}
                            validation={{
                              ...validateEmailAddress(),
                            }}
                            required={true}
                            errors={errors}
                            watch={watch}
                            placeholder="xxx@shibuya-shibukatsu.com"
                            isStatic={isConfirmation}
                          />
                          <div className={isConfirmation ? "d-none" : ""}>
                            <MypageTextField
                              name="mail_confirm"
                              label="(確認用)"
                              subLabel={true}
                              maxLength={100}
                              register={register}
                              validation={{
                                ...validateEmailAddress(),
                                ...validateConfirm(
                                  "mail",
                                  "mail_confirm",
                                  "メールアドレス"
                                ),
                              }}
                              errors={errors}
                              watch={watch}
                              placeholder="xxx@shibuya-shibukatsu.com"
                            />
                          </div>
                          <MypageTextField
                            name="phone"
                            label="電話番号(ハイフン無し)"
                            maxLength={11}
                            register={register}
                            validation={{ ...validatePhoneWithoutHyphen() }}
                            errors={errors}
                            watch={watch}
                            required={true}
                            placeholder="0312345678"
                            isStatic={isConfirmation}
                          />
                          <MypagePostcodeTextField
                            register={register}
                            errors={errors}
                            watch={watch}
                            required={true}
                            isStatic={isConfirmation}
                            setValue={setValue}
                            placeholder="123-4567"
                            autocomplete="postal-code"
                          />
                          <MypageSelect
                            name="pref"
                            label="都道府県"
                            register={register}
                            errors={errors}
                            required={true}
                            isStatic={isConfirmation}
                            options={prefOptions}
                            watch={watch}
                            isSetdefalut={true}
                          />
                          <MypageTextField
                            name="address"
                            label="市区町村以下"
                            maxLength={100}
                            register={register}
                            errors={errors}
                            watch={watch}
                            required={true}
                            placeholder="渋谷区渋谷"
                            isStatic={isConfirmation}
                          />
                          <h2 className="p-course-page__heading mt-5">
                            ご利用上の注意事項
                          </h2>
                          <div className="mb-5">
                            <ul className="p-list">
                              <li className="p-list__item">
                                お問い合わせいただいた内容への回答にお時間をいただく場合がございます。
                              </li>
                              <li className="p-list__item">
                                ご入力いただいた個人情報については、
                                <a
                                  href="https://www.city.shibuya.tokyo.jp/kusei/joho-kokai/joho-kokai/joho_kokai.html"
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  個人情報保護制度
                                </a>
                                の定めるところにより、適正に取り扱います。
                              </li>
                              <li className="p-list__item">
                                お電話番号やメールアドレス等の事項が不正確である場合や、お問い合わせの内容によっては、回答を差し上げられない場合がございます。
                              </li>
                              <li className="p-list__item">
                                いただいたお問い合わせへの返信は、下記メールアドレスよりお送りいたします。メールの設定などにより受信できない場合がございますので、設定をご確認ください。
                                <p className="p-mail-img">
                                  <img
                                    src="/common/assets/images/ans_mail01.png"
                                    alt="sec-manabishienshibuya.tokyo"
                                  />
                                </p>
                                <p className="p-mail-img">
                                  <img
                                    src="/common/assets/images/ans_mail02.png"
                                    alt="sec-katsuyakushienshibuya.tokyo"
                                  />
                                </p>
                                <p className="p-mail-img">
                                  <img
                                    src="/common/assets/images/ans_mail03.png"
                                    alt="hachikou-universityshibuya.tokyo"
                                  />
                                </p>
                              </li>
                            </ul>
                          </div>
                          <div className={isConfirmation ? "d-none" : ""}>
                            <p className="text-center">
                              <label>
                                <input
                                  type="checkbox"
                                  onChange={(e) => ConsentCheck(e)}
                                />
                                ご利用上の注意事項に同意する
                              </label>
                            </p>
                          </div>
                          <div className="p-login-form__btnbox">
                            {isConfirmation ? (
                              <div className="p-login-form__returnbtn">
                                <input
                                  className="p-login-form__link"
                                  type="button"
                                  value="入力に戻る"
                                  onClick={() => handleBackConfirmation()}
                                />
                              </div>
                            ) : (
                              <div className="p-login-form__returnbtn">
                                <a
                                  href={
                                    typeof prevlink !== "undefined"
                                      ? prevlink
                                      : process.env
                                          .REACT_APP_SHIBUKATSU_WEB_DOMAIN +
                                        "/contact/"
                                  }
                                >
                                  <input
                                    className="p-login-form__link"
                                    type="button"
                                    value="戻る"
                                  />
                                </a>
                              </div>
                            )}
                            <div className="p-login-form__send">
                              <input
                                className="p-login-form__link"
                                type="submit"
                                value={
                                  isConfirmation
                                    ? "送信する"
                                    : "入力内容を確認する"
                                }
                                disabled={!isConsent}
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </div>
          </main>
          <Footer is_login={false} />
        </div>
      </div>
    </>
  );
};

export default Inquiry;
